import './c-accordion-list.scss';
import template from './accordion-list.vhtml';

export default {
	template,
	data() {
		return {
			accordionEl: [],
		};
	},
	mounted() {
		this.accordionEl = this.$children;

		// Add events
		this.accordionEl.forEach( el => {
			el.$on( 'selected', uid => {
				this.accordionEl.forEach( el => {
					el.$data.isSelected = ( el._uid === uid || el.$data.isSelected === true );
				});
			});
		});

		
	},
	methods: {

	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/accordion-list/accordion-list.js